export default {
  name: "CoinsIcon",
  props: {
    width: {
      type: String,
      default: "16"
    },
    height: {
      type: String,
      default: "16"
    },
    color: {
      type: String,
      default: "#E05E0F"
    }
  }
};